import src from "IMAGE";
export default { src, width: 728, height: 179, blurWidth: 0, blurHeight: 0};
